module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.taskInfoLoading),
      expression: "taskInfoLoading"
    }],
    staticClass: "task-details-header-container"
  }, [_c('div', {
    staticClass: "cover"
  }, [_c('img', {
    attrs: {
      "src": _vm.url || (_vm.IMG_HOST + "default.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "header-right-container"
  }, [_c('div', [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('p', {
    staticClass: "reward"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('comb.anchorPay')))]), _vm._v(" "), (_vm.prePay) ? _c('span', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v(_vm._s(_vm.prePay.direct.multiplier) + _vm._s(_vm.prePay.unit))]) : _vm._e(), _vm._v(" "), (_vm.royaltyShareRatio && _vm.prePay && _vm.prePay.direct.multiplier) ? _c('span', {
    staticStyle: {
      "margin": "0 5px"
    }
  }, [_vm._v("+")]) : _vm._e(), _vm._v(" "), (_vm.royaltyShareRatio) ? _c('span', [_vm._v(_vm._s(_vm.royaltyShareRatio ? _vm.royaltyShareRatio : 0) + "%" + _vm._s(_vm.$t('word.sharePay')))]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "require-item info"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('comb.taskInfo')))]), _c('span', [_vm._v(_vm._s(_vm.categoryLabel))])]), _vm._v(" "), _c('p', {
    staticClass: "require-item require"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('comb.taskRequirement')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.demandDeliveryFrequency))]), _vm._v(" "), (_vm.demandTotalChapter) ? _c('span', [_vm._v("(" + _vm._s(_vm.$t('word.total')) + _vm._s(_vm.demandTotalChapter) + _vm._s(_vm.$t('word.episode')) + ")")]) : _vm._e(), _vm._v(" "), (_vm.demandWorkSize) ? _c('span', [_vm._v("(" + _vm._s(_vm.demandWorkSize) + _vm._s(_vm.$t('word.minute')) + ")")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.way) + "\n            ")])]), _vm._v(" "), _c('p', {
    staticClass: "require-item num"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('comb.recruitmentAmount')))]), _c('span', [_vm._v(_vm._s(_vm.userCount) + " " + _vm._s(_vm.$t('word.people')))])]), _vm._v(" "), _c('p', {
    staticClass: "require-item track"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('comb.releaseMode')))]), _c('span', [_vm._v(_vm._s(_vm.releaseWay))])])]), _vm._v(" "), _c('div', [(_vm.allowOperate && _vm.viewStatusId !== 4) ? _c('el-button', {
    on: {
      "click": function($event) {
        _vm.taskEnd()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('comb.taskFinished')))]) : _vm._e(), _vm._v(" "), (_vm.allowOperate && _vm.recruitmentType === 2 && (_vm.viewStatusId == 1 || _vm.viewStatusId == 2)) ? _c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('comb.prolongPeriodOfAddition')))]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.multiProlongPeriodOfAddition,
      "size": "tiny"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.days),
      callback: function($$v) {
        _vm.days = $$v
      },
      expression: "days"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v(_vm._s(_vm.$t('comb.prolongPeriodOfAddition')))]), _vm._v(" "), _c('template', {
    slot: "append"
  }, [_vm._v(" " + _vm._s(_vm.$t('word.day')))])], 2), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('word.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.extendTime
    }
  }, [_vm._v(_vm._s(_vm.$t('word.ok')))])], 1)], 1), _vm._v(" "), (_vm.viewStatusId == 4) ? _c('div', {
    staticClass: "task-end"
  }) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6acf00a0!./~/vue-loader/lib/selector.js?type=template&index=0!./views/copyrighter/taskManagement/TaskDetailsHeader.vue
// module id = 1069
// module chunks = 0